// extracted by mini-css-extract-plugin
module.exports = {"MobileNavToggle":"MobileNavToggle_MobileNavToggle__sMh7x","open":"MobileNavToggle_open__ZEi_0"};